import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ValidationResponse } from '../../../../types/ValidationResponse';
import { createOrder } from '../../../common/api/clients/order.api';

export const useEnquiryCreate = () => {
    return useMutation<
        Awaited<ReturnType<typeof createOrder>>,
        AxiosError<ValidationResponse>,
        Parameters<typeof createOrder>[0]
    >({
        mutationFn: createOrder,
    });
};
